import { connect } from 'react-redux';
import AnnualExpensesView from './AnnualExpenseView';
import {
  currentClientId,
  iterator,
  isPopulatedSelector,
  isGoingForwardSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { updateData } from '../../AdvWorkflow/AdvWorkflowActions';
import { healthcareGoalSelector } from '../HealthcareWorkflowSelector';
import { BACKEND_KEY } from '../HealthcareWorkflowConstants';
import { selectIsCanadian } from '../../../CommonSelectors/CommonAreaSelector';

const mapStateToProps = (state, ownProps) => {
  const healthcareGoal = healthcareGoalSelector(state, ownProps);

  const { AnnualExpense: annualExpense, EstimateExpenses: estimateExpenses } = healthcareGoal;

  return {
    clientId: currentClientId(state, ownProps),
    annualExpense,
    estimateExpenses,
    iterator: iterator(state, ownProps),
    isPopulated: isPopulatedSelector(state, ownProps),
    isGoingForward: isGoingForwardSelector(state, ownProps),
    isCanadian: selectIsCanadian(state),
  };
};

const mapDispatchToProps = dispatch => ({
  updateEstimateExpenses: (workflowId, clientId) => EstimateExpenses =>
    dispatch(updateData({ [BACKEND_KEY]: { EstimateExpenses } }, workflowId, clientId)),
  updateAnnualExpense: (workflowId, clientId) => ({ target: { value: AnnualExpense } }) =>
    dispatch(updateData({ [BACKEND_KEY]: { AnnualExpense } }, workflowId, clientId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AnnualExpensesView);
